import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/SupportWebsiteNavEntryPointQuery$parameters';

export const horizontalNavigationCsmSupportWebsiteEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-horizontal-navigation-csm-support-website-entrypoint" */ './src/ui/SupportWebsiteNavEntryPoint.tsx'
			),
		{ includeInShellOnlySsrBundle: true },
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				SupportWebsiteNavEntryPointQuery: {
					parameters,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
